

import translation from './translation.json'
import common from './common.json'
import yup from './yup.json'
import moment from './moment.json'

const pt = {
    app: translation,
    common,
    yup,
    moment
}

export default pt